export default {
  detail: {
    all_projects_caption: "Neue Projekte erscheinen automatisch",
    title: "Personalplanung",
    all_projects: "Alle Projekte",
    actions: "Aktionen",
    // `month`/`week`/`day` beschriften die Schaltflächen auf einer breiten Leiste; die Richtungs-
    // wortlaute sind Tooltip und barrierefreier Name - und alles, was bleibt, sobald die
    // Schaltflächen ihren Text ablegen.
    nav: {
      month: "Monat",
      week: "Woche",
      day: "Tag",
      today: "Heute",
      prev_month: "Einen Monat zurück",
      prev_week: "Eine Woche zurück",
      prev_day: "Einen Tag zurück",
      next_day: "Einen Tag vor",
      next_week: "Eine Woche vor",
      next_month: "Einen Monat vor",
    },
    zoom: {
      in: "Vergrößern",
      out: "Verkleinern",
      reset: "Zoom zurücksetzen",
    },
    search: {
      projects: "Projekt suchen",
      employees: "Mitarbeiter suchen",
      clear: "Suche leeren",
      count: "{shown} von {total} angezeigt",
    },
    sections: {
      projects: "Projekte",
      employees: "Mitarbeiter",
      capacity: "Kapazität",
    },
    // Beschriftet die Schaltflächen, mit denen ein Abschnitt den Bildschirm übernimmt und die
    // übrigen als schmale Leisten daneben ein- und ausgeklappt werden.
    expand: {
      enter: "Abschnitt vergrößern",
      exit: "Vergrößerung beenden",
      show: "Abschnitt einblenden",
      hide: "Abschnitt ausblenden",
    },
    // Der Name der Linie zwischen zwei Abschnitten, die man höher oder tiefer zieht. Nur für Screenreader.
    resize: {
      line: "Trennlinie zwischen {above} und {below}",
    },
    // Der Abschnitt „Kapazität“: „Geplant“ ist die Summe aller Phasen und nur zum Lesen, jede Phase
    // hat eine eigene Linie. Ein Klick auf eine Phase in der Legende macht ihre Linie ziehbar.
    capacity: {
      heading: "Legende",
      planned: "Geplant",
      planned_caption: "Summe aller Phasen",
      planned_caption_all_projects: "Summe aller Projekte",
      planned_row_hint:
        "Punkte der Linie ziehen, um den Bedarf eines Tages zu ändern. Die Änderung geht an die Phase dieses Tages.",
      personnel: "Personal",
      personnel_caption: "Eingeplante Personen",
      edit_planned: "Geplante Kapazität einer Phase für einen Zeitraum setzen",
      edit_action: "Kapazität bearbeiten",
      phase_row_hint: "Anklicken, um den Bedarf dieser Phase im Diagramm zu ziehen",
      phase_row_focused: "Diese Phase wird bearbeitet: Punkte der farbigen Linie ziehen. Erneut anklicken zum Beenden.",
      no_phase: "Ohne Phase ist kein Bedarf planbar",
      phases_hidden: "Phasen ausgeblendet ({count})",
      phases_hidden_hint: "Projekte oben suchen, um ihre Linien zu sehen",
      add_phase: "Phase anlegen",
      menu: {
        focus_named: "Linie: {phase}",
        unfocus_named: "Beenden: {phase}",
        edit_period: "Zeitraum setzen …",
        edit_phase: "Phase bearbeiten …",
        preview_phase: "Phasen-Vorschau",
        go_start: "Zum Phasenbeginn",
        go_end: "Zum Phasenende",
        open_project: "Projekt öffnen",
        edit_day: "Tag bearbeiten …",
        edit_week: "Woche bearbeiten …",
        average: "Ø {count} Personen pro Arbeitstag",
        day_totals: "Geplant {planned} · Personal {personnel} · Bilanz {balance}",
      },
    },
  },
  // Der Link zum eingebauten Kalender aller Projekte in der Seitenüberschrift (LewAllProjectsBanner).
  overall: {
    title: "Gesamtplanung",
    subtitle: "Alle laufenden und kommenden Projekte in einem Kalender. Neue Projekte erscheinen automatisch.",
    subtitle_short: "Alle Projekte in einem Kalender",
    running_short: "{count} laufend",
    planned_short: "{planned}/{needed} heute",
    planned_short_no_need: "{planned} heute",
    understaffed_short: "alle Tage besetzt | {count} Tag unterbesetzt | {count} Tage unterbesetzt",
    running: "Laufende Projekte",
    upcoming: "keine weiteren geplant | {count} weiteres geplant | {count} weitere geplant",
    planned_today: "Heute eingeplant",
    needed_today: "von {count} benötigten Personen | von {count} benötigten Person | von {count} benötigten Personen",
    no_need_today: "Heute kein Bedarf geplant",
    understaffed: "Unterbesetzte Tage",
    understaffed_within: "in den nächsten {days} Tagen",
    fully_staffed: "Die nächsten {days} Tage sind besetzt",
  },
  overview: {
    title: "Personalplanung",
    subtitle: "Planen und verwalten Sie Ihre Personalressourcen-Kalender.",
    actions: {
      create_new: "Neuer Kalender",
    },
    multiple_projects: "Mehrere Projekte",
    // Benennt die Icon-Schaltflächen auf jeder Kalenderkarte. Alle drei wiederholen sich je Karte,
    // deshalb wird der Kalendername an der Aufrufstelle angehängt.
    card: {
      pin: "Anpinnen",
      unpin: "Loslösen",
      open: "Kalender öffnen",
    },
    sections: {
      pinned: "Angepinnt",
      all: "Alle Kalender",
    },
    search: {
      label: "Kalender suchen",
    },
    filter: {
      label: "Filter",
      heading: "Projekte filtern",
      show_all: "Alle Projekte",
      show_active: "Aktive Projekte",
      show_future: "Zukünftige Projekte",
      show_completed: "Abgeschlossene Projekte",
    },
    sort: {
      label: "Sortieren",
      heading: "Sortieren nach",
      updated_at: "Zuletzt aktualisiert",
      created_at: "Erstelldatum",
    },
  },
  create: {
    title: "Personalplanungskalender erstellen",
    subtitle: "Erstellen Sie einen neuen Kalender für die Personalressourcenplanung.",
    name_label: "Kalendername",
    projects_label: "Projekte auswählen",
    projects_count: "{selected} von {total} Projekten ausgewählt",
    // Solange die Gesamtzahl noch nicht da ist: "2 von 2" hieße, alles sei ausgewählt.
    projects_count_selected: "{selected} ausgewählt",
    action: "Erstellen",
    validation: {
      name_required: "Kalendername ist erforderlich",
      projects_required: "Mindestens ein Projekt muss ausgewählt werden",
    },
  },
  empty_state: {
    title: "Keine Kalender verfügbar",
    subtitle: "Erstellen Sie einen neuen Kalender, um zu beginnen",
  },
  pinned_empty_hint: "Ziehen Sie Kalender hierher, um sie anzupinnen",
  unpinned_empty_hint: "Ziehen Sie Kalender hierher",
  properties: {
    assignment: "Zuweisung",
    employee: "Mitarbeiter",
    team: "Trupp",
    project: "Projekt",
    phase: "Phase",
    absence: "Abwesenheit",
    fromDate: "Von-Datum",
    toDate: "Bis-Datum",
    span: "Umfang",
    fromTime: "Von-Uhrzeit",
    toTime: "Bis-Uhrzeit",
    name: "Name",
  },
  actions_menu: {
    // Benennt den Auslöser des Überlaufmenüs selbst — ein Icon ohne Text daneben.
    label: "Kalenderoptionen",
    popout: "Kalendar Popout",
    rename: "Umbenennen",
    open_details: "Projektdetails öffnen",
    delete: "Löschen",
  },
  dialog: {
    employee_add_to_calendar: {
      title: "Mitarbeiter zum Kalender hinzufügen",
      actions: {
        add: "Hinzufügen",
        cancel: "Abbrechen",
      },
    },
    team_add_to_calendar: {
      title: "Team zum Kalender hinzufügen",
      actions: {
        add: "Hinzufügen",
        cancel: "Abbrechen",
      },
    },
    project_add_selector: {
      title: "Wählen Sie Projekte zum Hinzufügen zum Kalender aus",
      autocomplete: {
        project: "Projekt",
        projects_count: "{selected} von {total} Projekten ausgewählt",
        // Solange die Gesamtzahl noch nicht vom Server kam: nur zählen, keine Gesamtzahl behaupten.
        projects_count_selected: "{selected} ausgewählt",
        select_all: "Alle auswählen",
        clear_all: "Auswahl löschen",
      },
      actions: {
        add: "Hinzufügen",
        cancel: "Abbrechen",
      },
    },
    team_selector: {
      title: "Wählen Sie Trupps zum Hinzufügen zum Kalender aus",
      create_title: "Erstellen Sie einen neuen Trupp",
      tab_existing: "Bestehende Trupps",
      tab_create: "Neuen Trupp erstellen",
      name: "Truppname",
      name_required: "Truppname ist erforderlich",
      color: "Trupp Farbe",
      members: "Mitarbeiter",
      autocomplete: {
        team: "Trupp",
      },
    },
    employee_add_selector: {
      title: "Wählen Sie Mitarbeiter zum Hinzufügen zum Kalender aus",
      autocomplete: {
        employee: "Mitarbeiter",
      },
    },
    add_team: {
      title: "Trupp hinzufügen",
      subtitle: "Trupp auswahl",
      autocomplete: {
        team: "trupp",
        no_users: "Keine Mitarbeiter in diesem Trupp vorhanden",
        loading: "Lädt...",
        no_teams: "Keine Trupps gefunden",
        all_teams_selected: "Alle Trupps sind bereits ausgewählt",
      },
      actions: {
        add: "Hinzufügen",
      },
    },
    remove_timeline: {
      team: {
        title: "Zeitstrahl löschen?",
        text: "Alle team mitglieder in dem Zeitraum entfernen?",
      },
      title: "Zeitstrahl löschen?",
      text: "Möchten Sie diesen Zeitstrahl wirklich löschen?",
    },
    preview_project: {
      title: "Projekt Vorschau",
    },
    preview_project_phase: {
      title: "Phasen Vorschau",
      not_found: "Phase nicht gefunden",
    },
    capacity_edit: {
      title: "Geplante Kapazität bearbeiten",
      hint: "Die Linie „Geplant“ ist die Summe aller Phasen. Hier ändern Sie, was eine Phase in einem Zeitraum plant.",
      phase: "Phase",
      from: "Von",
      to: "Bis",
      mode: {
        set: "Feste Anzahl setzen",
        reset: "Auf Durchschnitt zurücksetzen",
      },
      persons: "Personen für diese Phase pro Tag",
      average: "Durchschnitt der Phase: {count} Personen pro Arbeitstag",
      work_days_only: "Nur Arbeitstage des Projekts",
      reset_hint:
        "Die Tage folgen wieder dem Durchschnitt der Phase ({count} Personen pro Arbeitstag, an freien Tagen niemand). Eigene Werte im Zeitraum werden entfernt.",
      preview: {
        days: "{count} Tage im Zeitraum",
        changed: "{count} ändern sich",
        unchanged: "nichts ändert sich im Diagramm",
        phase: "Diese Phase",
        total: "Geplant gesamt",
      },
      edit_days_in_phase: "Einzelne Tage der Phase bearbeiten",
      validation: {
        required: "Dieses Feld ist erforderlich",
        end_after_start: "Das Enddatum muss nach dem Startdatum liegen",
        outside_phase: "Das Datum liegt außerhalb der Phase",
        not_negative: "Bitte eine ganze Zahl ab 0 eingeben",
        no_days: "Im Zeitraum liegt kein Arbeitstag des Projekts",
      },
      actions: {
        save: "Speichern",
        cancel: "Abbrechen",
      },
    },
    assign_project: {
      title: "Projekt zuweisen",
      subtitle: "Wählen sie ein Projekt zum zuweisen eines Mitarbeiters aus:",
      period_label: "Zeitraum",
      start_date: "Startdatum",
      end_date: "Enddatum",
      project_period: "Projektzeitraum",
      phase_period: "Phasenzeitraum",
      autocomplete: {
        project: "Projekt",
        phase: "Phase",
        no_phase_found: "Keine Phase gefunden",
      },
      validation: {
        phase_required: "Phase ist erforderlich",
        start_date_required: "Startdatum ist erforderlich",
        end_date_required: "Enddatum ist erforderlich",
        start_after_end: "Startdatum darf nicht nach dem Enddatum liegen",
        end_before_start: "Enddatum darf nicht vor dem Startdatum liegen",
        start_before_phase_start: "Startdatum darf nicht vor dem Phasenbeginn ({date}) liegen",
        start_before_project_start: "Startdatum darf nicht vor dem Projektbeginn ({date}) liegen",
        start_after_phase_end: "Startdatum darf nicht nach dem Phasenende ({date}) liegen",
        start_after_project_end: "Startdatum darf nicht nach dem Projektende ({date}) liegen",
        end_before_phase_start: "Enddatum darf nicht vor dem Phasenbeginn ({date}) liegen",
        end_before_project_start: "Enddatum darf nicht vor dem Projektbeginn ({date}) liegen",
        end_after_phase_end: "Enddatum darf nicht nach dem Phasenende ({date}) liegen",
        end_after_project_end: "Enddatum darf nicht nach dem Projektende ({date}) liegen",
      },
      actions: {
        assign: "Zuweisen",
      },
    },
    multi_assign_project: {
      selected_employees: "Ausgewählte Mitarbeiter",
      time_period: "Zeitraum",
      team_members: "Team-Mitglieder",
      no_employees_selected: "Keine Mitarbeiter ausgewählt",
    },
    preview_employee: {
      title: "Mitarbeiter Vorschau",
    },
    edit_employee: {
      title: "Benutzer bearbeiten",
    },
    assign_employee: {
      title: "Mitarbeiter zuweisen",
      subtitle: "Wählen sie Mitarbeiter zum zuweisen auf ein Projekt aus:",
      autocomplete: {
        employee: "Mitarbeiter",
      },
      actions: {
        assign: "Zuweisen",
      },
    },
    assign_absence: {
      title: "Abwesenheit zuweisen",
      employees_label: "Mitarbeiter",
      time_span_label: "Tagesspanne",
      span_fullday: "Ganztags",
      span_halfday: "Halbtags",
      span_custom: "Benutzerdefiniert",
      from_time_label: "Von Zeit",
      to_time_label: "Bis Zeit",
      absence_type_label: "Abwesenheitsart",
      additional_options_label: "Zusätzliche Optionen",
      include_weekends: "Wochenende einschließen",
      include_holidays: "Feiertage einschließen",
      actions: {
        assign: "Zuweisen",
      },
    },
    edit_timeline: {
      title: "Zeitstrahl bearbeiten",
      subtitle: "Bearbeiten Sie den Zeitraum des Zeitstrahls:",
      start_date: "Startdatum",
      end_date: "Enddatum",
      days: "{n} Tag | {n} Tage",
      days_before: "{days} (bisher {before})",
      units: {
        day_1: "1 Tag",
        day_5: "5 Tage",
        week_1: "1 Woche",
      },
      validation: {
        start_before_end: "Das Startdatum muss vor dem Enddatum liegen",
        end_after_start: "Das Enddatum muss nach dem Startdatum liegen",
      },
    },
    calendar_rename: {
      title: "Kalender umbenennen",
      name_label: "Kalendername",
      rename: "umbenennen",
      validation: {
        required: "Kalendername ist erforderlich",
      },
      actions: {
        save: "Speichern",
        cancel: "Abbrechen",
      },
    },
    team_edit: {
      title: "Trupp bearbeiten",
      name_label: "Truppname",
      color_label: "Trupp Farbe",
      validation: {
        required: "Feld ist erforderlich",
      },
      actions: {
        save: "Speichern",
        cancel: "Abbrechen",
      },
    },
    team_members_manage: {
      title: "Trupp Mitglieder verwalten",
      team_name: "Truppname",
      add_member: "Mitglied hinzufügen",
      members_label: "Mitarbeiter",
      current_members: "Aktuelle Mitglieder",
      no_members: "Keine Mitglieder im Trupp",
      actions: {
        save: "Speichern",
        cancel: "Abbrechen",
      },
    },
    employee_remove: {
      title: "Benutzer entfernen?",
      text: "Möchten Sie diesen Benutzer inklusive aller seiner Zuweisungen aus dem Kalender wirklich entfernen?",
      actions: {
        remove: "Entfernen",
        cancel: "Abbrechen",
      },
    },
    project_remove: {
      title: "Projekt entfernen?",
      text: "Möchten Sie dieses Projekt inklusive aller seiner Zuweisungen aus dem Kalender wirklich entfernen?",
      actions: {
        remove: "Entfernen",
        cancel: "Abbrechen",
      },
    },
    add_project_phase: {
      title: "Phase hinzufügen",
      project_name: "Projektname",
      phase_name: "Phasenname",
      start_date: "Beginn",
      end_date: "Ende",
      color: "Farbe",
      average_capacity: "Durchschnittliche Kapazität",
      validation: {
        required: "Dieses Feld ist erforderlich",
        end_after_start: "Enddatum muss nach dem Startdatum liegen",
      },
      actions: {
        add: "Hinzufügen",
        cancel: "Abbrechen",
      },
    },
    edit_project_phase: {
      title: "Phase bearbeiten",
      project_name: "Projektname",
      phase_name: "Phasenname",
      start_date: "Beginn",
      end_date: "Ende",
      color: "Farbe",
      average_capacity: "Durchschnittliche Kapazität",
      validation: {
        required: "Dieses Feld ist erforderlich",
        end_after_start: "Enddatum muss nach dem Startdatum liegen",
      },
      actions: {
        save: "Speichern",
        cancel: "Abbrechen",
      },
    },
    project_color_edit: {
      title: "Projekt Farbe bearbeiten",
      color_label: "Projekt Farbe",
      actions: {
        save: "Speichern",
        cancel: "Abbrechen",
      },
    },
    calendar_delete: {
      title: "Kalender löschen?",
      text: "Möchten Sie diesen Kalender wirklich löschen?",
      actions: {
        delete: "Löschen",
        cancel: "Abbrechen",
      },
    },
  },
}
